module.exports = __webpack_public_path__ + "favicon-152-9a3f438b3a08b0316c92d95d0e655c1d.bundle.png";